<template>
   <div class="container">
    <!-- Push Wrapper -->
    <div class="mp-pusher" id="mp-pusher">

      <div class="scroller"><!-- this is for emulating position fixed of the nav -->

        <div class="scroller-inner">
          <transition 
            name="slide" 
            enter-active-class="slideInDown" 
            leave-active-class="slideOutUp"
          >
            <notifier 
              :type="notification.type"
              :title="notification.title"
              :message="notification.msg" 
            ></notifier>
          </transition>

          <utility-watcher></utility-watcher>

          <app-header></app-header>

          <app-main v-if="isReady"></app-main>
          <div v-else id="main">
            <div class="spinner-border spinner-border-sm" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <app-footer></app-footer>

        </div><!-- /.scroller-inner -->

      </div><!-- /.scroller -->

    </div><!-- /.mp-pusher -->

  </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'
import Header from './components/Header.vue'
import Main from './components/Main.vue'
import Footer from './components/Footer.vue'
import Notifier from './components/Notifier.vue'
import UtilityWatcher from './components/Utility-Watcher.vue'

// Axios
window.axios = axios
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = Laravel.csrfToken

// Dev
// Adds the basic auth hash to the headers, as for some reason that's
// the only way to prevent the basic auth modal from triggering on every
// ajax request.
if (window.location.hostname == 'dev.energypricebook.com') {
  window.axios.defaults.headers.common['Authorization'] = 'Basic ZGV2OmVwYjIwMjFkZXY='
}

export default {
  components: {
    'notifier': Notifier,
    'utility-watcher': UtilityWatcher,
    'app-header': Header,
    'app-main': Main,
    'app-footer': Footer,
  },
  data() {
    return {
      isReady: false,
      idleModalVisible: false,
      logoutId: null,
    }
  },
  computed: {
    userPlan() {
      return this.$store.getters.userPlan
    },
    notification() {
      return this.$store.getters.notification
    },
  },
  onIdle() {
    if (!this.idleModalVisible) {

      this.idleModalVisible = true
      this.logoutId = window.setTimeout(this.logout, 180000) // 3 minutes
      
      const swalContent = document.createElement('div')
      swalContent.innerHTML = `
        <h2 class="mrgn-btm-15 sz-j error">Session Timeout Warning</h2>
        <p class="align-l italic">Your current session will expire in 3 minutes <br>due to inactivity.</p>`

      swal({
        content: swalContent,
        closeOnEsc: false,
        closeOnClickOutside: false,
        buttons: {
          stay: {
            text: 'Stay Logged In',
            closeModal: true,
          },
          logout: {
            text: 'Log Off',
          }
        }
      }).then(value => {
        switch (value) {
          case 'stay':
            this.idleModalVisible = false
            this.logoutId = null
            this.$store.dispatch('setUser')
            break

          case 'logout':
            this.logout()
            break
        }
      })
    }
  },
  onActive() {
    window.clearTimeout(this.logoutId)
  },
  async created() {

    // Show an alert when a concurrent session is detected.
    axios.interceptors.response.use(response => {
      if (response.status == 401 && response.data.errorCode == 'concurrent-session') {
        this.$store.dispatch('setConcurrentSessionAlert', {
          msg: response.data.error
        })
      }
      return response
    })

    // Setup
    await this.$store.dispatch('init')

    console.log('isReady')
    this.isReady = true
  },
  mounted() {
    // Warn user before leaving app.
    setTimeout(() => { 
      this.warnUserOnLeave()
    }, 500)
  },
  methods: {
    logout() {
      window.location.href = '/auth/logout?timeout=1'
    },
    warnUserOnLeave() {
      document.querySelectorAll('#menu a, .page-header a.non-app-link, .page-footer a').forEach(link => {
        link.addEventListener('click', e => {
          
          // Only issue warning if a utility has been selected.
          if (this.$store.getters.userPlan.slug === 'free' || !this.$store.getters.utilityId || this.$store.getters.utilityId == '') {
            return
          }
          
          e.preventDefault()

          const targetHref = e.target.href
          const swalContent = document.createElement('div')
          swalContent.innerHTML = '<p class="alerts message alerts--no-brdr alerts--close-btn">This action will clear any unsaved changes, are you sure you want to leave?</p>'

          swal({
            content: swalContent,
            closeOnEsc: false,
            closeOnClickOutside: false,
            buttons: {
              cancel: {
                text: "Cancel",
                value: null,
                visible: true,
                className: "",
                closeModal: true,
              },
              confirm: {
                text: "Yes",
                value: true,
                visible: true,
                className: "",
                closeModal: true,
              }
            }
          }).then(result => {
            if (result) {
              window.location.href = targetHref
            }
          }).catch(() => {})
        })
      })
    }
  }
}
</script>
